import api from "@/api";

const namespaced = true;

const state = {
  bargeOverview: {}
}

const getters = {
  bargeOverview: state => state.bargeOverview
}

const mutations = {
  SET_BARGE_OVERVIEW: (state, payload) => {
    state.bargeOverview = payload;
  }
}

const actions = {
  async fetchBargeOverview({ commit }, payload) {
    try {
      const { data } = await api.getBargeOverviewKpi(payload)

      if (data.error) {
        commit('SET_BARGE_OVERVIEW', null)
        return
      }

      commit('SET_BARGE_OVERVIEW', data)
    } catch (error) {
      throw error;
    }
  }
}

export default { namespaced, state, getters, mutations, actions }